import React from 'react';
import PropTypes from 'prop-types';
import ModalContent from './ModalContent';
import EventDatePicker from './EventDatePicker';

const StepEventDate = (props) => {
  const { eventDate, setEventDate } = props;

  return (
    <div>
      <ModalContent
        heading="Deployment Date"
        body="Please select the date of the deployment to ensure accurate records and data alignment."
      />
      <EventDatePicker eventDate={eventDate} setEventDate={setEventDate} />
    </div>
  );
};

StepEventDate.propTypes = {
  eventDate: PropTypes.string,
  setEventDate: PropTypes.func,
};

StepEventDate.defaultProps = {
  eventDate: '',
  setEventDate: () => {},
};

export default StepEventDate;
